export default "__VITE_ASSET__72316dae__"